import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ModalComponent } from '../../core/components/modal/modal.component';
import { Client } from '../../core/models/client';
import { ClientsService } from '../../core/services/clients.service';
import { PopUpService } from '../../core/services/pop-up.service';

@Component({
  selector: 'lms-client-delete',
  templateUrl: './client-delete.component.html',
  styleUrls: ['./client-delete.component.scss']
})
export class ClientDeleteComponent implements OnInit {
  @Input() client: Client;
  @Output() delete = new EventEmitter<any>();
  @ViewChild('deleteClientModal', { static: false }) public deleteClientModal: ModalComponent;

  public action: string;
  public confirmDeleteCheck: boolean = false;
  public canDelete: boolean = false;

  constructor(
    private clientsService: ClientsService,
    private popupService: PopUpService,
    private translate: TranslateService
  ) {}

  ngOnInit() {}

  get deleteInfoData() {
    return { users: this.client.accountSummary.identifiedUsersCount, admins: this.client.adminsCount };
  }

  public open(action) {
    this.action = action;
    this.confirmDeleteCheck = false;
    this.canDelete = this.action === 'delete' ? !this.client.hasActiveData : true;
    this.deleteClientModal.open();
  }

  confirmDelete() {
    if (this.action === 'delete') {
      this.deleteClient();
    } else {
      this.deleteClientData();
    }
  }

  deleteClient() {
    this.deleteClientModal.close();
    this.clientsService
      .delete(this.client.id)
      .then(() => this.delete.emit({ deleteClient: true }))
      .catch((err) => {
        this.popupService.showError({
          title: this.translate.instant('clients.deleteError'),
          text: err.serverMessage
        });
      });
  }

  deleteClientData() {
    this.deleteClientModal.close();
    this.clientsService
      .deleteClientAccountData(this.client.id)
      .then((res) => this.delete.emit({ deleteClientData: true, ...res }))
      .catch((err) => {
        this.popupService.showError({
          title: this.translate.instant('clients.deleteError'),
          text: err.serverMessage
        });
      });
  }
}
